import { FormControl as FormControlMui, styled } from '@mui/material';

export const FormControl = styled(FormControlMui)(() => ({
  display: 'flex',
  flexDirection: 'column',
  '& .MuiInputBase-readOnly': {
    background: 'transparent',
  },
}));
